'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBowtie = function IoBowtie(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 16.6s0.6-0.4 1.6-0.6c1.6-0.3 3-0.4 3.6 0.7 0.8 1.3 1.5 4.2 1.4 6.7-0.1 1.3-0.4 1.7-0.4 1.7s-1.2 0.8-3.7 0.5c-2.7-0.2-3.1-1.1-3.1-1.1s0.4-1 0.6-3.4 0-4.5 0-4.5z m-3.1 5.7c-1.4 0.3-3 0.7-3 0.7s3.5-0.3 5-0.7c-0.3 1.7-0.8 2.7-0.8 2.7s-6.5 6.3-9 6.3c-2.2 0-4.1-5.4-4.1-11.3s2-11.2 4.1-11.2c2.7 0 8.2 4.4 10 7.5 0 0 0.2 1.3 0.1 2.5-0.8-0.4-1.9-0.8-3.4-1.1-2.2-0.4-3.3-0.2-3.3-0.2s1.4 0.3 4.4 1.3c1.2 0.4 1.8 0.7 2.3 0.8 0 0.2-0.1 0.6-0.1 0.8 0 0.4 0 0.8 0 1.2-0.4 0.1-1.2 0.4-2.2 0.7z m19-13.5c2.1 0 4.1 5.3 4.1 11.2s-1.9 11.3-4.1 11.3c-2.9 0-8.1-5.4-8.7-6.2 0 0 0.3-0.4 0.4-1.7v-0.7c1.2 0.5 5.4 1 5.4 1s-1.6-0.5-3.1-0.9c-1-0.3-1.9-0.6-2.3-0.8-0.1-0.8-0.2-1.8-0.3-2.5 1.3-0.9 5.4-2.7 5.4-2.7s-1.2 0.2-2.8 0.7c-1.1 0.4-2.2 0.9-2.9 1.1-0.2-0.8-0.5-1.4-0.8-1.9 0-0.1 0-0.3 0-0.3v-0.1c1.7-3.1 6.9-7.6 9.7-7.6z' })
        )
    );
};

exports.default = IoBowtie;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/bowtie.js
// module id = 1969
// module chunks = 0